import React, { useEffect } from "react";
import WhyMinemiSection from "./WhyMinemiSection";
import LoanCheckerForm from "./LoanCheckerForm";
import HeroSection from "./HeroSection";
import ComparisonSection from "./ComparisonSection";
import HowItWorksSection from "./HowItWorksSection";
import TestimonialSection from "./TestimonialSection";
import SecuritySection from "./SecuritySection";
import FaqSection from "./FaqSection";
import FinalCta from "./FinalCta";
import ScrollToTopbutton from "./ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center">
      <Helmet>
        <title>Check Your Loan Approval Chances - Minemi</title>
      </Helmet>
      <HeroSection />
      <div id="form-section" className="w-full">
        <LoanCheckerForm />
      </div>
      <WhyMinemiSection />
      <HowItWorksSection />
      <ComparisonSection />
      <TestimonialSection />
      <SecuritySection />
      <FaqSection />
      <FinalCta />
      <ScrollToTopbutton />
    </div>
  );
};

export default LandingPage;
